import { IsNotEmpty, IsString, IsNumber, IsOptional, IsInt, IsPositive } from 'class-validator';
import { PersonDto } from './person.dto';
import { UserDto } from './user.dto';
import { CreateContactsDto } from './contacts';
import { Type } from 'class-transformer';
import { ManagerLinkDto } from './link-manager.dto';
import { CityInfoDto } from './geo/city';
import { MediaInfoDto } from './media-basic-data.dto';
import { InvoiceDto } from './invoice.dto';
import { OkvedInfoDto } from './okved.dto';
import { TagDto } from './tags';

export class CreateCompanyDto {
  @IsNotEmpty()
  @IsString()
    name: string;

  isClient: boolean;
  isSupplier: boolean;
  isMedia: boolean;
  isCompetitor: boolean;

  @IsNumber()
  @IsOptional()
    cityId: number;

  @IsOptional()
  @IsInt()
  @IsPositive()
    managerId?: number;

  @Type(() => CreateContactsDto)
    contacts?: CreateContactsDto;

  okvedIds: number[];
  
  okved: OkvedInfoDto[];
}

export class CompanyDto extends CreateCompanyDto {
  id: number;
  // users: UserDto[];
  city: CityInfoDto;
  media?: MediaInfoDto[];
  sellerInvoices?: InvoiceDto[];
  buyerInvoices?: InvoiceDto[];
  tags: TagDto[];
  lastEventDate?: Date;
}

export class UpdateCompanyDto extends CreateCompanyDto {
  id: number;
}

export class LegalEntityCompanyDto {
  id: number;
  company: CompanyDto;
}

export class CreateCompanyLegalEntityDto {
  companyId: number;
  legalEntityId: number;
}

export class CompanyWithManagersDto extends CompanyDto {
  viaPerson?: PersonDto;
  managers: UserDto[];
  duplicateCompanies?: Pick<CompanyDto, 'id' | 'name'>[];
}

export class CompanyToCombineDto {
  id: number;
  name: string;
  managers: ManagerLinkDto[];
  legalEntitiesCount: number;
  clientInvoicesCount: number;
  supplierInvoicesCount: number;
  leadsCount: number;
  city: CityInfoDto;
}

export class CombineCompaniesDto {
  newName: string;
  cityId: number;
  companiesIds: number[];
}
